<template>
  <shop-data>
    <div class="page page-shop content">
      <template v-if="bookings && bookings.length > 0">
        <h1 class="shop__title">{{ t('shop.title') }}</h1>

        <SuccessMessage class="shop__message" v-if="currentRoute.query.booked">
          {{ t('shop.bookingSuccess') }}
        </SuccessMessage>

        <h2>{{ t('shop.activePackages') }}</h2>

        <ul class="shop">
          <li class="shop__item" v-for="item in bookings" :key="item.bookingId">
            <article-preview
              :title="item.article.name"
              :description="item.article.articleDescription"
              :price="roundPrice(item.article.vatPrice)"
              :link="`/shop/buchung/${item.bookingId}`"
              :icon="item.article.iconUrl"
            />
          </li>
        </ul>
      </template>
      <template v-if="articles && articles.length > 0">
        <h2>{{ t('shop.availablePackages') }}</h2>
        <ul class="shop">
          <li class="shop__item" v-for="item in articles" :key="item.articleId">
            <article-preview
              :title="item.name"
              :description="item.description"
              :price="roundPrice(item.vatPrice)"
              :link="`/shop/artikel/${item.articleId}`"
              :icon="item.iconUrl"
              :showAsDisabled="noShopYet"
              :articleType="item.articleType"
            />
          </li>
        </ul>
      </template>
      <template v-if="orders && orders.length > 0">
        <h2>{{ t('shop.recentOrders') }}</h2>
        <ul class="shop">
          <li class="shop__item" v-for="item in orders" :key="item.bookingId">
            <article-preview
              :title="item.article.name"
              :description="item.article.articleDescription"
              :price="roundPrice(item.article.vatPrice)"
              :icon="item.article.iconUrl"
              :articleType="item.article.articleType"
            />
          </li>
        </ul>
      </template>
      <p>
        {{ t('shop.pricesNote') }}<br />
        {{ t('shop.paymentNote') }}<br />
        {{ t('shop.legalPrefix') }}
        <a target="_blank" rel="noopener noreferrer" :href="tosUrl">{{ t('shop.termsLabel') }}</a>,
        {{ t('shop.legalMiddle') }}
        <a target="_blank" rel="noopener noreferrer" :href="privacyUrl"
        >{{ t('shop.privacyLabel') }}</a
        >.
      </p>
    </div>
  </shop-data>
</template>

<script setup>
  import { computed } from 'vue'
  import ArticlePreview from '@/components/shop/ArticlePreview.vue'
  import ShopData from '@/components/shop/ShopData.vue'
  import { legalUrls } from '@/composables/useLegal.ts'
  import SuccessMessage from '@/components/SuccessMessage.vue'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useShopStore } from '@/stores/useShopStore'
  import { useUnits } from '@/composables/useUnits.ts'
  import { useRoute } from 'vue-router'

  const { t } = useStrings()
  const shopStore = useShopStore()
  const currentRoute = useRoute()
  const { roundPrice } = useUnits()
  const bookings = computed(() => shopStore.bookings)
  const articles = computed(() => shopStore.bookableArticles)
  const orders = computed(() => shopStore.orders)
  const { tosUrl, privacyUrl } = legalUrls()
  const noShopYet = computed(() => shopStore.inactive === true)
</script>

<style lang="scss">
.page-shop {
  max-width: 80ch;
}

.shop {
  display: grid;
  grid-template-columns: 1fr;
  gap: $spacer05;
  list-style: none;
  margin: 0 0 $spacer20 0;
  padding: 0;

  @media (min-width: $bp-md) {
    margin-bottom: $spacer40;
    gap: $spacer20;
  }
}

.shop__title {
  margin-bottom: 2rem;
}

.shop__message {
  margin-bottom: $spacer20;
}
</style>
